<template>
  <div id="company-data-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">DADOS DA EMPRESA</h2>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <form class="panel__content needs-validation">

          <div class="row">
            <p class="col-12 col-sm-6">
              <input :class="{ 'input': true, 'is-invalid': errors.has('razao_social') }" name="razao_social"
                v-validate="'required'" type="text" class="form-control" v-model="user.razao_social" id="razao_social"
                placeholder="Razão Social" value="">
              <span class="invalid-feedback">
                {{ errors.first('razao_social') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input :class="{ 'input': true, 'is-invalid': errors.has('nome_fantasia') }" name="nome_fantasia"
                v-validate="'required'" type="text" class="form-control" v-model="user.nome_fantasia" id="nome_fantasia"
                placeholder="Nome Fantasia" value="">
              <span class="invalid-feedback">
                {{ errors.first('nome_fantasia') }}
              </span>
            </p>
          </div>


          <div class="row">
            <p class="col-12 col-sm-6">
              <masked-input v-validate="'required|cnpj'" type="text" name="cnpj" class="form-control"
                :class="{ 'is-invalid': errors.has('cnpj') }" v-model="user.cnpj"
                :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask" :guide="false" placeholder="CNPJ: 00.000.000/0000-00">
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first('cnpj') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input type="text" name="ie" class="form-control" :class="{ 'is-invalid': errors.has('ie') }" v-model="user.ie"
                placeholder="Inscrição Estadual">

              <span class="invalid-feedback">
                {{ errors.first('ie') }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-6">
              <masked-input v-validate="'required|min:14'" type="text" name="emp_fone" class="form-control"
                :class="{ 'is-invalid': errors.has('emp_fone') }" v-model="user.emp_fone"
                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask" :guide="false" placeholder="Telefone: ">
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first('emp_fone') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input v-validate="'min:1'" type="text" name="emp_site" class="form-control"
                :class="{ 'is-invalid': errors.has('emp_site') }" v-model="user.emp_site" placeholder="Website">

              <span class="invalid-feedback">
                {{ errors.first('emp_site') }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-6">
              <input type="text" name="ramo_atividade" class="form-control"
                :class="{ 'is-invalid': errors.has('ramo_atividade') }" v-model="user.ramo_atividade"
                placeholder="Ramo de Atividade">

              <span class="invalid-feedback">
                {{ errors.first('ramo_atividade') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">

              <select name="qtd_func" v-model="user.qtd_func" class="form-control"
                :class="{ 'is-invalid': errors.has('qtd_func') }">
                <option value="">Selecione a quantidade de funcionários</option>
                <option value="Até 5">Até 5</option>
                <option value="De 6 a 10">De 6 a 10</option>
                <option value="De 11 a 15">De 11 a 15</option>
                <option value="De 16 a 20">De 16 a 20</option>
                <option value="De 21 a 30">De 21 a 30</option>
                <option value="De 31 a 50">De 31 a 50</option>
                <option value="mais de 50">mais de 50</option>
              </select>

              <span class="invalid-feedback">
                {{ errors.first('qtd_func') }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col">
              <input :class="{ 'input': true, 'is-invalid': errors.has('emp_email') }" name="emp_email"
                class="form-control" v-validate="'required'" v-model="user.emp_email" id="emp_email"
                placeholder="E-mail da empresa" value="">
              <span class="invalid-feedback">
                {{ errors.first('emp_email') }}
              </span>
            </p>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    clube: {
      required: true,
      type: Object
    },
  },
  methods: {
    async submit() {
      const result = await this.$validator.validateAll([
        'razao_social',
        'nome_fantasia',
        'cnpj',
        'ie',
        'emp_fone',
        'emp_site',
        'emp_email',
        'qtd_func',
        'ramo_atividade',
      ]);

      try {
        if (await result) {
          return true;
        } else {
          throw new Error('Preencha os campos corretamente');
        }
      } catch (error) {
        console.log(error)
        return false;
      }
    },
  }
})
</script>